<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja" class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
          </li>
          <li class="item-link">
            <span>Cotação Express</span>
          </li>
        </ul>
      </div>
      <div class="main-content-area">
        <!-- <form @submit.prevent="continueAction"> -->
        <div class="wrapper-wizard-step-0" v-if="this.currentStep == 0">
          <div class="row">
            <div class="col-md-12">
              <h3 class="box-title">MINHA COTAÇÃO</h3>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <FormHelper
                :inputVar="formCotacao.assunto"
                :form="formCotacao"
                label="Assunto/Proposta"
              ></FormHelper>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <FormHelper
                :inputVar="formCotacao.mensagem"
                :form="formCotacao"
                label="Mensagem/Comentário"
                type="textarea"
                rows="3"
              ></FormHelper>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <h3 class="box-title">DESTINATÁRIOS</h3>
            </div>
          </div>

          <div class="row">
            <div id="emails-box" class="col-md-12">
              <label class="custom-label" for="emails">
                E-mails
                <span>*</span>
              </label>
              <input-tag
                id="emails"
                class="custom-tagbox"
                v-model="formCotacao.emails"
                :placeholder="'Digite o email e pressione enter'"
                :validate="'email'"
                :add-tag-on-keys="[13,188,9]"
              />
              <span id="email-error" class="invalid-feedback">Por favor, preencha o campo acima</span>
            </div>
          </div>

          <div id="cliente" v-if="this.showCliente">
            <div class="row">
              <div class="col-md-12">
                <h3 class="box-title">CLIENTE</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <FormHelper
                  :inputVar="formCliente.codigo"
                  :form="formCliente"
                  :mask="['#-#', '##-#', '###-#', '####-#', '#####-#', '######-#']"
                  label="Código"
                  placeholder="Ex: 1234-2"
                  :lostFocus="buscaCliente"
                ></FormHelper>
              </div>
              <div class="col-md-9">
                <FormHelper
                  :inputVar="formCliente.razaoSocial"
                  :form="formCliente"
                  disabled="true"
                  label="Razão Social"
                ></FormHelper>
              </div>
              <div class="col-md-1 col-only-button">
                <button aria-label="Novo Cliente" class="btn primary-button" v-on:click.prevent="loadCliente()">Novo</button>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <h3 class="box-title">ADICIONAR PRODUTOS</h3>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2">
              <FormHelper
                :inputVar="formAddProdutos.codigo"
                :form="formAddProdutos"
                :mask="['#-#', '##-#', '###-#', '####-#', '#####-#', '######-#']"
                label="Código"
                placeholder="Ex: 1234-2"
                :lostFocus="buscaProduto"
              ></FormHelper>
            </div>
            <div class="col-md-1">
              <FormHelper
                :inputVar="formAddProdutos.quantidade"
                :form="formAddProdutos"
                label="Qtde"
                mask="####"
              ></FormHelper>
            </div>
            <div class="col-md-2">
              <FormHelper
                :inputVar="formAddProdutos.PreCoRevenda"
                :form="formAddProdutos"
                label="Preço Revenda (UN)"
                type="money"
                disabled="true"
              ></FormHelper>
            </div>
            <div class="col-md-2">
              <FormHelper
                :inputVar="formAddProdutos.valorCliente"
                :form="formAddProdutos"
                type="money"
                label="Preço Cliente (UN)"
              ></FormHelper>
            </div>
            <div class="col-md-1 col-only-button">
              <button aria-label="Adicionar Produto" class="btn primary-button" v-on:click.prevent="addProduto()">
                <i class="fa fa-plus-circle fa-lg" />
              </button>
            </div>
          </div>

          <div id="list-prods">
            <div class="row">
              <div class="col-md-12">
                <table style="width:100%">
                  <tr class="cart-table-header">
                    <th class="text-center">
                      <i class="fa fa-times fa-lg" />
                    </th>
                    <th class="text-center">Código</th>
                    <th class="text-center">Foto</th>
                    <th>Descrição</th>
                    <th class="text-center">Qtde</th>
                    <th class="text-center">Valor Revenda</th>
                    <th class="text-center" style="color:red">Valor (EUP)</th>
                    <th class="text-center">Total</th>
                  </tr>
                  <tr
                    class="cart-table-data"
                    v-for="(produto, index) in formCotacao.produtoList"
                    :key="index"
                  >
                    <td class="text-center">
                      <a
                        class="fa fa-times fa-lg"
                        style="color:red"
                        v-on:click.prevent="removeProduto(index)"
                        href="#"
                      />
                    </td>
                    <td class="text-center">{{produto.Produto}}</td>
                    <td class="text-center">
                      <img class="cart-table-img" v-bind:src="produto.PrdCaminho" />
                    </td>
                    <td class="description">{{produto.Descricao}}</td>
                    <td class="text-center">
                      <input
                        class="form-control cart-num-input"
                        v-on:change="updateQtd(index, produto)"
                        v-model="produto.Quantidade"
                        type="number"
                        min="1"
                      />
                    </td>
                    <td class="text-center">{{formatCurrency(produto.PreCoRevenda)}}</td>
                    <td class="text-center">{{formatCurrency(produto.Preco)}}</td>
                    <td class="text-center">{{formatCurrency(produto.Total)}}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <span class="cart-table-foot pull-left">
                  <i class="fa fa-shopping-cart fa-lg" />
                  Itens({{totalItensList}})
                </span>
              </div>
              <div class="col-md-6">
                <span class="cart-table-foot pull-right">Total: {{totalValueList}}</span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <h3 class="box-title">CONDIÇÕES COMERCIAIS</h3>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <FormHelper
                :inputVar="formCotacao.formaPagamento"
                :form="formCotacao"
                :options="formaPagOptions()"
                label="Forma de Pagamento"
                type="radio"
              ></FormHelper>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <FormHelper
                :inputVar="formCotacao.observacoes"
                :form="formCotacao"
                label="Observações"
                type="textarea"
                rows="3"
              ></FormHelper>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <h3 class="box-title">CONTATO</h3>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <FormHelper :inputVar="formCotacao.contatoNome" :form="formCotacao" label="Nome"></FormHelper>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <FormHelper :inputVar="formCotacao.contatoEmpresa" :form="formCotacao" label="Empresa"></FormHelper>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FormHelper :inputVar="formCotacao.contatoSite" :form="formCotacao" label="Site"></FormHelper>
            </div>
            <div class="col-md-6">
              <FormHelper
                :inputVar="formCotacao.contatoEmail"
                :form="formCotacao"
                type="email"
                label="Email"
              ></FormHelper>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FormHelper
                :inputVar="formCotacao.contatoFone"
                :form="formCotacao"
                :mask="['(##) ####-####', '(##) #####-####']"
                label="Fone"
              ></FormHelper>
            </div>
            <div class="col-md-6">
              <FormHelper
                :inputVar="formCotacao.contatoFax"
                :form="formCotacao"
                label="Fax"
                mask="(##) ####-####"
              ></FormHelper>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FormHelper
                :inputVar="formCotacao.contatoEndereco"
                :form="formCotacao"
                label="Endereço"
              ></FormHelper>
            </div>
            <div class="col-md-6">
              <FormHelper
                :inputVar="formCotacao.contatoCep"
                :form="formCotacao"
                label="CEP"
                mask="#####-###"
              ></FormHelper>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FormHelper
                :inputVar="formCotacao.contatoEstado"
                :form="formCotacao"
                :options="getStates()"
                type="select"
                label="Estado"
                placeholder="Selecione um Estado"
              ></FormHelper>
            </div>
            <div class="col-md-6">
              <FormHelper
                :inputVar="formCotacao.contatoCidade"
                :form="formCotacao"
                :options="formCotacao.cidades"
                :disabled="formCotacao.cidadeDisabled"
                type="select"
                label="Cidade"
                placeholder="Selecione uma Cidade"
              ></FormHelper>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="alert alert-info text-center" role="alert">
                <p>Sujeito à aprovação de cadastro/crédito</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <button aria-label="Excluir Cotação" class="btn btn-danger" v-on:click.prevent="deleteAction()">Excluir Cotação</button>
            </div>
            <div class="col-md-6">
              <button
                aria-label="Continuar"
                class="btn btn-primary pull-right"
                v-on:click.prevent="continueAction()"
              >Continuar</button>
            </div>
          </div>
        </div>

        <!-- Step 2 -->
        <div class="wrapper-wizard-step-1" v-show="this.currentStep == 1">
          <div class="row">
            <div class="col-md-12">
              <h3 class="box-title">MINHA COTAÇÃO</h3>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-default panel-primary">
                <div class="panel-heading">Informações Gerais</div>
                <div class="panel-body">
                  <strong v-html="formCotacao.assunto.value"></strong>
                  <p v-html="formCotacao.mensagem.value"></p>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-default">
                <div class="panel-heading">Produtos</div>
                <div class="panel-body">
                  <ul v-for="(produto, index) in formCotacao.produtoList" :key="index">    
                    <h1 style="border-top:solid 1px Silver;" v-if="index > 0"></h1>                 
                    <li>                     
                      <div class="col50flex">
                        <h3 class="azul">{{produto.SubDescricao}}</h3>
                        <strong>Codigo {{produto.Produto}}</strong>
                        <p class="text--black">{{produto.Descricao}}</p>
                        <span class="price-big">{{formatCurrency(produto.Preco)}} x {{produto.Quantidade}}</span>
                        <br>
                        <br>
                        <span
                          class="vl-total"
                        >Total {{formatCurrency(produto.Preco * produto.Quantidade)}}</span>

                        <hr />

                        <b> {{ produto.Produto }} {{ produto.SubDescricao }} </b>
                        <br>
                        <br>
                        <ul style="border-top:solid 1px Silver; width:50%;padding-left: 0px">
                          <li>Peso bruto: {{ formatMedidas(produto.Peso) }} Kg </li>
                          <li>Dimensão: {{ formatMedidas(produto.Altura) }} cm x {{ formatMedidas(produto.Largura) }} cm x {{ formatMedidas(produto.Comprimento) }} cm </li>
                          <li>NCM: {{ produto.Ncm }} </li>
                          <li>EAN: {{ produto.PrdAbnt }} </li>
                        </ul>
                      </div>
                      <div class="col50flex">
                        <img v-bind:src="produto.PrdCaminho" />
                      </div>
                      <hr />
                    </li>                                     
                  </ul>
                </div>
                <div class="panel-footer">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="qtde-itens">
                        <i class="fa fa-shopping-cart"></i>
                        Itens ({{totalItensList}})
                      </div>
                    </div>
                    <div class="col-lg-6"> 
                      <div class="total-itens pull-right">
                        <strong>Total:</strong>
                        {{totalValueList}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <h3 class="box-title">CONDIÇÕES COMERCIAIS</h3>
              <span class="condicao-pagamento" v-if="this.formCotacao.formaPagamento.value">A Prazo</span>
              <span class="condicao-pagamento" v-if="!this.formCotacao.formaPagamento.value">A Vista</span>

              <p v-html="this.formCotacao.observacoes.value"></p>
            </div>
            <div class="col-md-6">
              <h3 class="box-title">CONTATO</h3>
              <p
                class="contato-empresa"
              >{{this.formCotacao.contatoNome.value}} / {{this.formCotacao.contatoEmpresa.value}}</p>
              <div class="grid">
                <div>
                  <strong>
                    <i class="fa fa-globe"></i>
                  </strong>
                  {{this.formCotacao.contatoSite.value}}
                </div>
                <div>
                  <strong>
                    <i class="fa fa-envelope-o"></i>
                  </strong>
                  {{this.formCotacao.contatoEmail.value}}
                </div>
                <div>
                  <strong>
                    <i class="fa fa-phone"></i>
                  </strong>
                  {{this.formCotacao.contatoFone.value}}
                </div>
                <div>
                  <strong>
                    <i class="fa fa-fax"></i>
                  </strong>
                  {{this.formCotacao.contatoFax.value}}
                </div>
                <div>
                  <strong>
                    <i class="fa fa-map-marker"></i>
                  </strong>
                  {{this.formCotacao.contatoEndereco.value}}
                </div>
                <div>
                  <strong>
                    <i class="fa fa-map-signs"></i>
                  </strong>
                  {{this.formCotacao.contatoCep.value}}
                  <span
                    v-if="this.formCotacao.contatoCidade.value"
                  > - {{this.formCotacao.contatoCidade.value.label !== undefined ? this.formCotacao.contatoCidade.value.label : this.formCotacao.contatoCidade.value}}</span>
                  <span
                    v-if="this.formCotacao.contatoEstado"
                  > / {{this.formCotacao.contatoUf}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="alert alert-info text-center" role="alert">
                <p>Sujeito à aprovação de cadastro/crédito</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <button aria-label="Excluir Cotação" class="btn btn-danger" v-on:click.prevent="deleteAction()">Excluir Cotação</button>
            </div>
            <div class="col-md-2 pull-right">
              <button
                aria-label="Voltar"
                class="btn btn-primary pull-left"
                v-on:click.prevent="backAction()"
              >Voltar</button>
              <button
                aria-label="Enviar"
                class="btn btn-primary pull-right"
                v-on:click.prevent="sendAction()"
              >Enviar</button>
            </div>
          </div>
        </div>
        <!-- </form> -->
      </div>
    </div>
  </main>
</template>
<script>
import FormHelper from "./partials/FormHelper.vue";
import InputTag from "vue-input-tag";
import axios from "axios";
import { async } from 'q';

export default {
  name: "ExpressQuotation",
  components: {
    FormHelper,
    InputTag
  },
  data() {
    return {
      currentStep: 0,
      showCliente: false,
      formCotacao: {
        codigoCliente: 0,
        attemptSubmit: false,
        assunto: new this.$formInput(true),
        mensagem: new this.$formInput(true),
        formaPagamento: new this.$formInput(false, false),
        observacoes: new this.$formInput(false),
        contatoNome: new this.$formInput(true),
        contatoEmpresa: new this.$formInput(false),
        contatoSite: new this.$formInput(false),
        contatoEmail: new this.$formInput(true),
        contatoFone: new this.$formInput(false),
        contatoFax: new this.$formInput(false),
        contatoEndereco: new this.$formInput(false),
        contatoCep: new this.$formInput(false),
        contatoCidade: new this.$formInput(false),
        contatoEstado: new this.$formInput(false),
        contatoUf: '',
        cidadeDisabled: true,
        produtoList: [],
        emails: [],
        cidades: []
      },
      formAddProdutos: {
        codigo: new this.$formInput(false),
        quantidade: new this.$formInput(false),
        PreCoRevenda: new this.$formInput(false),
        valorCliente: new this.$formInput(false),
        objeto : null
      },
      formCliente: {
        codigo: new this.$formInput(false),
        razaoSocial: new this.$formInput(false)
      }
    };
  },
  watch: {
    "formCotacao.contatoEstado.value": function(v) {
      jQuery("#cidade div div input").attr('autocomplete', 'new-password')
      this.loadCidades(v.code, 'this', false)
    },
    "formCotacao.attemptSubmit": function() {
      this.verifyEmails();
    },
    "formCotacao.emails.length": function() {
      this.verifyEmails();
    },
    "formAddProdutos.quantidade.length": function() {
     if(this.formAddProdutos.objeto != null){
       this.formAddProdutos.objeto.Quantidade = this.formAddProdutos.quantidade;
     }
    }    
  },
  mounted(){
    const self = this;
    $.ajax({
        url: this.$apiUrl + "Session.svc/getsessions",
        dataType: "json",
        type: "GET",
        xhrFields: { withCredentials: true },
        error: () => {
          swal({
            title: "É necessário estar logado",
            icon: "warning"
          }).then(() => location.href = `${self.$SiteUrl}/login?redirectTo=` + location.href)
        }
    });

    this.currentStep = localStorage.currentStep;
    jQuery("#list-prods").hide();
    jQuery("#email-error").hide();

    jQuery("#cidade div div input").attr('autocomplete', 'new-password')
    jQuery("#estado div div input").attr('autocomplete', 'new-password')
    jQuery("#email").attr('autocomplete', 'new-password')
    jQuery("#fone").attr('autocomplete', 'new-password')
    jQuery("#fax").attr('autocomplete', 'new-password')
    jQuery("#nome").attr('autocomplete', 'new-password')
    jQuery("#codigo").attr('autocomplete', 'new-password')
    jQuery("#emails input").attr('autocomplete', 'new-password')

    let _self = this;
    axios({
        method: "GET",
        url: this.$apiUrl + "Cliente.svc/getcnpj",
        withCredentials: true
      }).then(response => {
        if (response.data == "Sem Permissão") {
          this.showCliente = true;
        } else {
          this.showCliente = false;
        }
      });

      axios({
        method: "GET",
        url: this.$apiUrl + "Cotacao.svc/NovaCotacao",
        withCredentials: true
      }).then(response => {
        
    
        let o = response.data;
        this.formCotacao.contatoNome.value = o.ContatoNome;
        this.formCotacao.contatoEmpresa.value = o.ContatoEmpresa;
        this.formCotacao.contatoSite.value = o.ContatoSite;    
        this.formCotacao.contatoEmail.value = o.ContatoEmail;     
        this.formCotacao.contatoFone.value = o.ContatoFone != null ? o.ContatoFone.slice(1) : null;      
        this.formCotacao.contatoFax.value = o.ContatoFax;     
        this.formCotacao.contatoEndereco.value = o.ContatoEndereco;        
        this.formCotacao.contatoCep.value = o.ContatoCep;    
        this.formCotacao.contatoCidade.value = o.ContatoCidade;  
        this.formCotacao.assunto.value = o.Assunto;
        this.formCotacao.mensagem.value = o.Mensagem;
        this.formCotacao.observacoes.value = o.CondicoesObs;
        this.formCotacao.codigoCliente = o.ClienteInformado;
        this.formCotacao.formaPagamento.value = o.CondPagamento;
        

        if(o.Destinatarios != "" && o.Destinatarios != null){
          if(o.Destinatarios.includes(',')){
            let dest = o.Destinatarios.split(',');
            dest.forEach((element) => {
              this.formCotacao.emails.push(element);
            })
          }
          else{
            this.formCotacao.emails.push(o.Destinatarios);
          }
        }

        let states = this.getStates()

        let estado = states.filter(c => c.code === o.ContatoEstado)[0];        
        this.formCotacao.contatoEstado.value = estado.label;

        this.formCotacao.contatoUf = estado.code;

        this.loadCidades(estado.code, o.ContatoCidade, true)
      });

      this.getProducts();
  },
  computed: {
    formErrors: function () {
      // Retorna os campos que estão com erro de validação
      const errors = Object.keys(this.formCotacao).filter(
        (key) => this.formCotacao[key].validation && !this.formCotacao[key].validation.status
      );
      
      return errors.length;
    },
    totalValueList: function() {
      var totalValue = 0.0;
      if (this.formCotacao.produtoList.length > 0) {
        this.formCotacao.produtoList.forEach(function(element) {
          totalValue = totalValue + element.Total;
        });
      }
      return this.formatCurrency(totalValue);
    },
    totalItensList: function() {
      var totalList = this.formCotacao.produtoList.length;
      if (totalList > 0) {
        jQuery("#list-prods").show();
      } else {
        jQuery("#list-prods").hide();
      }
      return totalList;
    }
  },
  methods: {
    backAction: function() {
      this.currentStep = 0
      localStorage.currentStep = 0;
    },
    getProducts: function(){
      const self = this;
      axios({
          method: "GET",
          url: self.$apiUrl + "Cotacao.svc/getprodutos",        
          withCredentials: true,
          contentType :"application/json",
          dataType : 'json'
        }).then(response => {             
          response.data.forEach((element) => {
            this.formCotacao.produtoList.push(element);
          })              
        });
    },
    formaPagOptions: function() {
      const options = [
        { code: 1, label: "A Vista", value: false },
        { code: 2, label: "A Prazo", value: true }
      ];

      return options;
    },
    loadCliente: function() {
      const self = this;
      if(this.formCliente.codigo.value !== ''){
        axios({
          method: "POST",
          url: self.$apiUrl + "Cotacao.svc/novocliente",
          data : {
            clienteInformado : self.formCliente.codigo.value.split('-')[0],
          },
          withCredentials: true,
          contentType :"application/json",
          dataType : 'json'
        }).then(response => {
          if(response.data.includes("OK")){      
            self.formCotacao.codigoCliente = self.formCliente.codigo.value.split('-')[0];
            self.formCliente.codigo.value = null;
            self.formCliente.razaoSocial.value = null;
            if(self.formCotacao.produtoList.length > 0){
              self.getProducts();      
              swal({
                title: "Aviso",
                text: "Você mudou o cliente, todos os produtos digitados anteriormente foram excluídos automaticamente.",
                icon: "warning"
              })
            }            
          }
          else{
            self.formCliente.razaoSocial.value = response.data;
          }
        });
      }
      else{
        swal({
          title: "Informe o codigo do cliente",
          icon: "warning"          
        })
      }
    },
    buscaCliente : function(){  
      const self = this;
      if(this.formCliente.codigo.value !== ''){
        axios({
          method: "POST",
          url: self.$apiUrl + "Cotacao.svc/getrazaosocial",
          data : {
            cliente : self.formCliente.codigo.value.split('-')[0],
          },
          withCredentials: true,
          contentType :"application/json",
          dataType : 'json'
        }).then(response => {
          if(response.data.includes("recarregar")){
            location.reload()            
          }
          else{
            self.formCliente.razaoSocial.value = response.data;
          }
        });
      }
    },
    buscaProduto : function(){  
      const self = this;
      if(this.formAddProdutos.codigo.value !== ''){
        axios({
          method: "POST",
          url: self.$apiUrl + "Cotacao.svc/BuscarProduto",
          data : {
            produto : self.formAddProdutos.codigo.value,
            filial : 1
          },
          withCredentials: true,
          contentType :"application/json",
          dataType : 'json'
        }).then(response => {
          self.formAddProdutos.PreCoRevenda.value = response.data.PreCoRevenda;
          self.formAddProdutos.quantidade.value = response.data.QtdMinVenda;
          self.formAddProdutos.objeto = response.data;
          self.formAddProdutos.valorCliente.value = response.data.Preco;
        });
      }
    },
    addProduto: function() {
      let xhr = new XMLHttpRequest()
      xhr.open('POST', this.$apiUrl + "Cotacao.svc/adicionarproduto")
      xhr.setRequestHeader('Content-type', 'application/json')
      xhr.withCredentials = true

      xhr.onload = () => {
          if (xhr.status == 200) {
              let response = JSON.parse(xhr.responseText)    
              if(response === 'OK'){
                this.formCotacao.produtoList = []
                this.getProducts();
              }       
              else{
                swal({
                  title:"Aviso",
                  text: response,
                  icon: "warning"
                })
              }                           
          }
          else{
            swal({
              title: "Não foi possível adicionar produto",
              text: "Verifique os valores inseridos",
              icon: "error"
            })
          }
      }

      xhr.send(JSON.stringify({
          codigoComDv: this.formAddProdutos.codigo.value,
          filial: 1,
          valorCliente: this.formAddProdutos.valorCliente.value.toString().replace('.', ','),
          valorRevenda: this.formAddProdutos.PreCoRevenda.value.toString().replace('.', ','),
          quantidade: this.formAddProdutos.quantidade.value,
          ignorarVerificaValor: false
      }))      
    },
    removeProduto: function(prodIndex) {
      swal({
        title: "Exclusão de produto " + this.formCotacao.produtoList[prodIndex].Produto,
        text: "Confirma a exclusão?",
        buttons: ["Cancelar", "Excluir"],
        dangerMode: true,
      }).then((response) => {
        if(response){
          let xhr = new XMLHttpRequest()
          xhr.open('POST', this.$apiUrl + "Cotacao.svc/removerproduto")
          xhr.setRequestHeader('Content-type', 'application/json')
          xhr.withCredentials = true

          xhr.onload = () => {
              if (xhr.status == 200) {
                this.formCotacao.produtoList = [];
                this.getProducts();
              }
              else{
                swal({
                  title: "Erro",
                  text: "Não foi possível remover produto",
                  icon: "error"
                })
              }                
          }

          xhr.send(JSON.stringify({
              codigoProduto: this.formCotacao.produtoList[prodIndex].Produto,
          }))
        }
        else{
          return;
        }
      });                  
    },
    continueAction: function() {      
      if(this.formCotacao.produtoList.length > 0){
        this.formCotacao.attemptSubmit = true;
        // // console.log('errors', this.formErrors)
        if (this.formErrors === 0 && this.formCotacao.emails.length > 0) {
          let cotacao = {};
          let destinatarios = '';

          this.formCotacao.emails.forEach((element, index) => {
            if(index === this.formCotacao.emails.length - 1)
              destinatarios += element
            else
              destinatarios += element + ','
          })

          cotacao.Assunto = this.formCotacao.assunto.value;
          cotacao.Mensagem = this.formCotacao.mensagem.value;
          cotacao.Destinatarios = destinatarios;
          cotacao.Produtos = this.formCotacao.produtoList;
          cotacao.CondicoesPagamento = !this.formCotacao.formaPagamento.value ? 0 : 1;
          cotacao.CondPagamento = this.formCotacao.formaPagamento.value;
          cotacao.CondicoesObs = this.formCotacao.observacoes.value;
          cotacao.ContatoNome = this.formCotacao.contatoNome.value;
          cotacao.ContatoEmpresa = this.formCotacao.contatoEmpresa.value;
          cotacao.ContatoSite = this.formCotacao.contatoSite.value;
          cotacao.ContatoEmail = this.formCotacao.contatoEmail.value;
          cotacao.ContatoFone = this.formCotacao.contatoFone.value;
          cotacao.ContatoEndereco = this.formCotacao.contatoEndereco.value;
          cotacao.ContatoCep = this.formCotacao.contatoCep.value;
          cotacao.ContatoCidade = this.formCotacao.contatoCidade.value;
          cotacao.ContatoEstado = this.formCotacao.contatoEstado.value;   
          cotacao.ClienteInformado = this.formCotacao.codigoCliente;        

          let xhr = new XMLHttpRequest()
          xhr.open('POST', this.$apiUrl + "Cotacao.svc/salvarcotacao")
          xhr.setRequestHeader('Content-type', 'application/json')
          xhr.withCredentials = true

          xhr.onload = () => {
              if (xhr.status == 200) {
                  let response = JSON.parse(xhr.responseText)    
                  if(xhr.responseText.includes("OK")){
                    this.currentStep = 1;          
                    localStorage.currentStep = 1;
                  }       
                  else{
                    swal({
                      title:"Erro",
                      text: response,
                      icon: "error"
                    })
                  }                           
              }
              else{
                swal({
                  title: "Não foi possível prosseguir com a cotação",
                  icon: "error"
                })
              }
          }
          xhr.send(JSON.stringify( cotacao ))              
        }
        else{
          swal({
            title: "Aviso",
            text: "Preencha os campos obrigatórios",
            icon: "warning"          
          })
        }
        //// console.log("continue");
      }
      else{
        swal({
          title: "Aviso",
          text: "Nenhum produto foi informado",
          icon: "warning"          
        })
      }
    },
    sendAction: function() {
      this.formCotacao.attemptSubmit = true;
      const self = this;

      let cotacao = {};

      let destinatarios = '';

      this.formCotacao.emails.forEach((element, index) => {
        if(index === this.formCotacao.emails.length - 1)
          destinatarios += element
        else
          destinatarios += element + ';'
      })

      cotacao.Assunto = this.formCotacao.assunto.value;
      cotacao.Mensagem = this.formCotacao.mensagem.value;
      cotacao.Destinatarios = destinatarios;
      cotacao.Produtos = this.formCotacao.produtoList;
      cotacao.CondicoesPagamento = !this.formCotacao.formaPagamento.value ? 0 : 1;
      cotacao.CondPagamento = this.formCotacao.formaPagamento.value;
      cotacao.CondicoesObs = this.formCotacao.observacoes.value;
      cotacao.ContatoNome = this.formCotacao.contatoNome.value;
      cotacao.ContatoEmpresa = this.formCotacao.contatoEmpresa.value;
      cotacao.ContatoSite = this.formCotacao.contatoSite.value;
      cotacao.ContatoEmail = this.formCotacao.contatoEmail.value;
      cotacao.ContatoFone = this.formCotacao.contatoFone.value;
      cotacao.ContatoEndereco = this.formCotacao.contatoEndereco.value;
      cotacao.ContatoCep = this.formCotacao.contatoCep.value;
      cotacao.ContatoCidade = this.formCotacao.contatoCidade.value;
      cotacao.ContatoEstado = this.formCotacao.contatoEstado.value;  
      cotacao.ClienteInformado = this.formCotacao.codigoCliente;             

      let xhr = new XMLHttpRequest()
      xhr.open('POST', this.$apiUrl + "Cotacao.svc/enviarcotacao")
      xhr.setRequestHeader('Content-type', 'application/json')
      xhr.withCredentials = true

      xhr.onload = () => {
          if (xhr.status == 200) {
              let response = JSON.parse(xhr.responseText)    
              if(xhr.responseText.includes("sucesso")){
                localStorage.currentStep = 0;
                swal({
                  title: response,
                  icon: "success"
                }).then(() => {
                  location.href = `${self.$SiteUrl}/loja/minha-conta`
                })
              }       
              else{
                swal({
                  title:"Erro",
                  text: response,
                  icon: "error"
                })
              }                           
          }
          else{
            swal({
              title: "Não foi possível enviar cotação",
              icon: "error"
            })
          }
      }

      xhr.send(JSON.stringify( cotacao ));
    },
    deleteAction: function() {
      const self = this;
      swal({
        title:"Excluir cotação",
        text: "Deseja cancelar a cotação?",
        buttons: ["Cancelar", "Excluir"],
        dangerMode: true,
      })
      .then((response) => {
        if(response){
          this.formCotacao.attemptSubmit = false;
          axios({
            method: "GET",
            url: self.$apiUrl + "Cotacao.svc/excluircotacao",
            withCredentials: true,
            contentType :"application/json",
            dataType : 'json'
          }).then(response => {
            localStorage.currentStep = 0;
            location.reload();
          });
        }
      });      
    },
    updateQtd: function(index, produto) {
      produto.Total = produto.Quantidade * produto.Preco;
      this.$set(this.formCotacao.produtoList, index, produto);

      let xhr = new XMLHttpRequest()
      xhr.open('POST', this.$apiUrl + "Cotacao.svc/atualizarquantidade")
      xhr.setRequestHeader('Content-type', 'application/json')
      xhr.withCredentials = true

      xhr.onload = () => {
          if (xhr.status == 200) {
              let response = JSON.parse(xhr.responseText)   
              if(response === 'OK'){
                
              }       
              else{
                swal({
                  title:"Aviso",
                  text: response,
                  icon: "warning"
                })
              }                           
          }
          else{
            swal({
              title: "Erro",
              text: "Não foi possível atualizar a quantidade deste produto",
              icon: "error"
            })
          }
      }

      xhr.send(JSON.stringify({
          codigoProduto: produto.Produto,
          quantidade: produto.Quantidade
      }))    
    },
    verifyEmails: function() {
      if (
        this.formCotacao.attemptSubmit &&
        this.formCotacao.emails.length < 1
      ) {
        jQuery("#emails-box").addClass("error");
        jQuery("#email-error").show();
      } else {
        jQuery("#emails-box").removeClass("error");
        jQuery("#email-error").hide();
      }
    },
    formatCurrency: function(v) {
      //formada coluna de valores da tabela para moeda
      var formato = {
        minimumFractionDigits: 2,
        style: "currency",
        currency: "BRL"
      };
      return parseFloat(v).toLocaleString("pt-BR", formato);
    },
    formatMedidas: function(v) {
      //formada coluna de valores da tabela para moeda
      var formato = {
        minimumFractionDigits: 2
      };
      return parseFloat(v).toLocaleString("pt-BR", formato);
    },
    getStates: function() {
      // TODO: Fazer ajax para busca de estados
      const states = [
        {
          code: "AC",
          label: "Acre"
        },
        {
          code: "AL",
          label: "Alagoas"
        },
        {
          code: "AP",
          label: "Amapá"
        },
        {
          code: "AM",
          label: "Amazonas"
        },
        {
          code: "BA",
          label: "Bahia"
        },
        {
          code: "CE",
          label: "Ceará"
        },
        {
          code: "DF",
          label: "Distrito Federal"
        },
        {
          code: "ES",
          label: "Espírito Santo"
        },
        {
          code: "GO",
          label: "Goiás"
        },
        {
          code: "MA",
          label: "Maranhão"
        },
        {
          code: "MT",
          label: "Mato Grosso"
        },
        {
          code: "MS",
          label: "Mato Grosso do Sul"
        },
        {
          code: "MG",
          label: "Minas Gerais"
        },
        {
          code: "PA",
          label: "Pará"
        },
        {
          code: "PB",
          label: "Paraíba"
        },
        {
          code: "PR",
          label: "Paraná"
        },
        {
          code: "PE",
          label: "Pernambuco"
        },
        {
          code: "PI",
          label: "Piauí"
        },
        {
          code: "RJ",
          label: "Rio de Janeiro"
        },
        {
          code: "RN",
          label: "Rio Grande do Norte"
        },
        {
          code: "RS",
          label: "Rio Grande do Sul"
        },
        {
          code: "RO",
          label: "Rondônia"
        },
        {
          code: "RR",
          label: "Roraima"
        },
        {
          code: "SC",
          label: "Santa Catarina"
        },
        {
          code: "SP",
          label: "São Paulo"
        },
        {
          code: "SE",
          label: "Sergipe"
        },
        {
          code: "TO",
          label: "Tocantins"
        }
      ];

      return states;
    },
    loadCidades: function(code, cidadeSelect, load) {
      const self = this;
      let cidade = {};

      self.formCotacao.cidades = [];
      self.formCotacao.contatoCidade.value = null;      

      if (self.formCotacao.contatoEstado.value) {
        let codigoEstado = self.formCotacao.contatoEstado.value.code !== undefined ? self.formCotacao.contatoEstado.value.code : code
        if(code){
          this.formCotacao.contatoUf = codigoEstado;
        }

        $.ajax({
          url:
            this.$apiUrl +
            "Cidades.svc/getcidades/" +
             codigoEstado +
            "/N",
          dataType: "json",
          contentType: "application/json",
          type: "GET",
          success: data => {
            self.formCotacao.cidadeDisabled = false;
            data.forEach(element => {
              cidade = {};
              (cidade.code = element.CidCodigo),
                (cidade.label = element.CidCidade);
              self.formCotacao.cidades.push(cidade);
            });

            if (load)
              self.formCotacao.contatoCidade.value = cidadeSelect
          }
        });
      } else {
        self.formCotacao.cidadeDisabled = true;
        self.formCotacao.contatoCidade.value = null;
      }
    }
  }
};
</script>
<style>
#emails ::placeholder {
  color: #bbb;
}
</style>
